import { restapi } from './restapi';
import { type  Edition, type Template } from './types';


export function getTemplate(edId: number) {
	return restapi.get<Template[]>(`template/current-list/?edition=${edId}`).then(
		res => res.data[0] || {header: '', footer: ''},
	);
}

export function getEdition(edId: number) {
	return restapi.get<Edition>(`edition/${edId}/`).then(res => res.data);
}
